import React, { useEffect, useState } from 'react'

import AnimateHeight from 'react-animate-height'
import { AnimatedForm, Button, Form } from 'shared/components'
import { getContactCenterPhone } from 'shared/utils'

import { getFields } from './form'
import classes from './Info.module.scss'
import { FormTypes, DepartmentTypes } from 'models'
import { useLocation } from 'react-router-dom'

const formId = 'contacts-form'
export const prHash = '#pr'

const getFormTitle = (isPr: boolean): string | JSX.Element => {
  return isPr ? (
    <>
      Пресс-служба:{' '}
      <a href="mailto:pr.media@mts.ru" className="link color">
        pr.media@mts.ru
      </a>
    </>
  ) : (
    'Задать вопрос'
  )
}

export const Info = (): JSX.Element => {
  const location = useLocation()
  const [isPr, setIsPr] = useState(location.hash === prHash)
  const [isFormOpened, setFormOpened] = useState(isPr)
  const [isSubmit, setIsSubmit] = useState(false)
  const phone = getContactCenterPhone()
  const [formTitle, setFormTitle] = useState(getFormTitle(isPr))
  const [fields, setFields] = useState(
    getFields(isPr ? DepartmentTypes.Pr : undefined)
  )

  useEffect(() => {
    if (location.hash === prHash && !isPr) {
      setIsPr(true)
      setFormOpened(true)
      setFields(getFields(DepartmentTypes.Pr))
      setFormTitle(getFormTitle(true))
      window.scrollTo({ behavior: 'smooth', top: 0 })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.hash])

  const handleSubmit = () => {
    setIsSubmit(true)
  }

  const handleClose = () => {
    setIsSubmit(false)
    setFormOpened(false)
  }

  const cn = `col-xs-12 col-sm-6 col-md-6 col-lg-3 ${classes.item}`

  return (
    <div className={classes.wrapper}>
      <div className={`${classes.container} container`}>
        <AnimateHeight duration={400} height={!isFormOpened ? 'auto' : 0}>
          <div className={`${classes.row} row`}>
            <div className="col-xs-12">
              <h1 className={`${classes.title} uppercase`}>Контакты</h1>
            </div>

            <div className={cn}>
              <h3>Контактный центр</h3>
              <a
                className={`link ${classes.item__link}`}
                href={`tel:${phone.href}`}
              >
                {phone.text}
              </a>
            </div>

            <div className={cn}>
              <h3>Контакты отдела продаж</h3>
              <a className="link color" href="mailto:partners@kion.ru">
                partners@kion.ru
              </a>
            </div>

            <div className={cn}>
              <h3>Контакты PR</h3>
              <a className="link color" href="mailto:pr.kion@mts.ru">
                pr.kion@mts.ru
              </a>
            </div>

            <div className={cn}>
              <h3>Адрес</h3>
              <p>127051, Москва Петровский бульвар, д.12, стр.3, пом.6, эт.5</p>
            </div>

            <div className="col-xs-12">
              <Button
                className={classes.btn}
                onClick={() => setFormOpened(true)}
              >
                Задать вопрос
              </Button>
            </div>
          </div>
        </AnimateHeight>

        <AnimatedForm
          id={formId}
          duration={400}
          open={isFormOpened}
          onCloseClick={() => handleClose()}
          scrollToElement={false}
          scrollCenter={isSubmit}
        >
          <Form
            showed={isFormOpened}
            id={formId}
            fields={fields}
            title={formTitle}
            showUserAgreement
            onCloseClick={() => handleClose()}
            onAutoClose={() => handleClose()}
            onSubmit={() => handleSubmit()}
            type={FormTypes.Question}
            dark
            titleLarge
            onSelect={v => {
              const _isPr = v === DepartmentTypes.Pr
              setIsPr(_isPr)
              setFormTitle(getFormTitle(_isPr))
            }}
          />
        </AnimatedForm>
      </div>
    </div>
  )
}
